/* SultryStreet product page: variant picker, unavailable marking, sticky mobile buy bar. */
(function () {
  document.querySelectorAll('[data-nb-pdp]').forEach(function (root) {
    var form = root.querySelector('#NbProductForm');
    if (!form) return;
    var variants = JSON.parse(root.querySelector('[data-nb-variants]').textContent);
    var t = JSON.parse(root.querySelector('[data-nb-i18n]').textContent);
    var idInput = form.querySelector('[data-nb-variant-id]');
    var button = form.querySelector('[data-nb-add]');
    var price = root.querySelector('[data-nb-price]');
    var stock = form.querySelector('[data-nb-stock]');
    var sticky = root.querySelector('[data-nb-sticky]');
    var stickyAdd = root.querySelector('[data-nb-sticky-add]');
    var stickyPrice = root.querySelector('[data-nb-sticky-price]');
    function selected() {
      var picked = [];
      form.querySelectorAll('[data-nb-option]:checked').forEach(function (input) {
        picked[Number(input.dataset.nbOption)] = input.value;
      });
      return picked;
    }
    function markUnavailable(picked) {
      form.querySelectorAll('[data-nb-option]').forEach(function (input) {
        var index = Number(input.dataset.nbOption);
        var trial = picked.slice();
        trial[index] = input.value;
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return trial[i] === undefined || o === trial[i]; });
        });
        var label = form.querySelector('label[for="' + input.id + '"]');
        if (label) label.classList.toggle('is-unavailable', !match || !match.available);
      });
    }
    function syncSticky() {
      if (!sticky) return;
      stickyAdd.disabled = button.disabled;
      stickyAdd.textContent = button.textContent;
      stickyPrice.replaceChildren.apply(stickyPrice, Array.prototype.map.call(price.childNodes, function (n) { return n.cloneNode(true); }));
    }
    function update() {
      var picked = selected();
      form.querySelectorAll('[data-nb-option]:checked').forEach(function (input) {
        var span = form.querySelector('[data-nb-option-label="' + input.dataset.nbOption + '"]');
        var label = form.querySelector('label[for="' + input.id + '"]');
        if (span && label) span.textContent = label.textContent;
      });
      var v = variants.find(function (x) {
        return x.options.every(function (o, i) { return o === picked[i]; });
      });
      markUnavailable(picked);
      if (!v) { button.disabled = true; button.textContent = t.unavailable; stock.textContent = ''; syncSticky(); return; }
      idInput.value = v.id;
      price.textContent = v.price;
      if (v.compare) { var s = document.createElement('s'); s.textContent = v.compare; price.append(' ', s); }
      button.disabled = !v.available;
      button.textContent = v.available ? t.add : t.unavailable;
      stock.textContent = v.available && v.qty !== null && v.qty < 4 ? t.few.replace('__N__', v.qty) : '';
      syncSticky();
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    form.addEventListener('change', function (event) {
      if (event.target.matches('[data-nb-option]')) update();
    });
    markUnavailable(selected());
    if (sticky) {
      stickyAdd.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(button); else button.click();
      });
      var ticking = false;
      function check() {
        ticking = false;
        sticky.hidden = button.getBoundingClientRect().bottom > 0;
      }
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; window.requestAnimationFrame(check); }
      }, { passive: true });
      check();
    }
  });
})();
